<template>
  <b-container>
    <b-form-group :label="$t('vehicle.plate')" label-for="plate">
      <b-form-input
        id="plate"
        type="text"
        :placeholder="$t('vehicle.plate')"
        v-model="model.plate"
      />
      <span class="text-danger" v-if="modelstate['Plate']">
        {{ modelstate["Plate"][0] }}
      </span>
    </b-form-group>

    <b-form-group :label="$t('vehicle.vehicleType')" label-for="vehicleType">
      <VehicleTypeDropdownModal
        id="vehicleType"
        :vehicleTypeId.sync="model.vehicleTypeId"
      />
      <span class="text-danger" v-if="modelstate['VehicleTypeId']">
        {{ modelstate["VehicleTypeId"][0] }}
      </span>
    </b-form-group>

    <b-form-group :label="'Modelo de equipamento'" label-for="VehicleModelId">
      <vehicle-model-dropdown-modal
        id="VehicleModelId"
        :vehicleModelId.sync="model.vehicleModelId"
      />

      <span class="text-danger" v-if="modelstate['VehicleModelId']">
        {{ modelstate["VehicleModelId"][0] }}
      </span>
    </b-form-group>

    <b-form-group :label="$t('geral.costCenter')" label-for="CostCenterId">
      <cost-center-dropdown-modal
        id="CostCenterId"
        :readonly="false"
        :costCenterId.sync="model.costCenterId"
      />

      <span class="text-danger" v-if="modelstate['CostCenterId']">
        {{ modelstate["CostCenterId"][0] }}
      </span>
    </b-form-group>

    <b-form-group
      :label="$t('tracking.cargo.companyBranchName')"
      label-for="CompanyBranchId"
    >
      <company-branch-dropdown
        id="CompanyBranchId"
        :readonly="false"
        :value.sync="model.companyBranchId"
      >
      </company-branch-dropdown>
      <span class="text-danger" v-if="modelstate['CompanyBranchId']">
        {{ modelstate["CompanyBranchId"][0] }}
      </span>
    </b-form-group>

    <b-form-group
      :label="$t('vehicle.documentExpiration')"
      label-for="documentExpiration"
    >
      <b-form-input
        id="documentExpiration"
        type="date"
        :placeholder="$t('vehicle.documentExpiration')"
        v-model="model.documentExpiration"
      />
    </b-form-group>

    <b-form-group
      v-if="isHourmeter(model.vehicleTypeId)"
      label="Horimetro"
      label-for="hourimeter"
    >
      <b-form-input
        id="hourimeter"
        type="number"
        placeholder="Horimetro"
        v-model="model.hour"
      />
    </b-form-group>

    <b-form-group v-else :label="$t('vehicle.km')" label-for="km">
      <b-form-input
        id="km"
        type="number"
        placeholder="$t('vehicle.km')"
        v-model="model.km"
        step="1"
      />
    </b-form-group>

    <b-form-group :label="$t('vehicle.height')" label-for="height">
      <base-input-numeric
        id="height"
        :placeholder="$t('vehicle.height')"
        :value.sync="model.height"
      >
      </base-input-numeric>
    </b-form-group>

    <b-form-group :label="$t('vehicle.Width')" label-for="Width">
      <base-input-numeric
        id="Width"
        :placeholder="$t('vehicle.Width')"
        :value.sync="model.width"
      >
      </base-input-numeric>
    </b-form-group>

    <b-form-group :label="$t('vehicle.weight')" label-for="weight">
      <base-input-numeric
        id="weight"
        :placeholder="$t('vehicle.weight')"
        :value.sync="model.weight"
      >
      </base-input-numeric>
    </b-form-group>

    <b-form-group :label="$t('vehicle.length')" label-for="length">
      <base-input-numeric
        id="length"
        :placeholder="$t('vehicle.length')"
        :value.sync="model.length"
      >
      </base-input-numeric>
    </b-form-group>

    <!-- {{ model }} -->
  </b-container>
</template>

<script>
import AwesomeMask from "awesome-mask";

export default {
  name: "VehicleRegistrationCrud",
  props: {
    model: Object,
    modelstate: Object,
    allType: Array
  },
  directives: {
    mask: AwesomeMask
  },
  components: {
    "base-input-numeric": () =>
      import("@/components_rms/base/BaseInputNumeric.vue"),
    "company-branch-dropdown": () =>
      import("@/components_rms/company/CompanyBranchDropdown.vue"),
    "vehicle-model-dropdown-modal": () =>
      import(
        "@/components_rms/System/VehicleModel/VehicleModelDropdownModal.vue"
      ),
    VehicleTypeDropdownModal: () =>
      import(
        "@/components_rms/vehicle/VehicleType/VehicleTypeDropdownModal.vue"
      ),
    "cost-center-dropdown-modal": () =>
      import("@/components_rms/System/CostCenter/CostCenterDropdownModal.vue")
  },
  data() {
    return {};
  },
  methods: {
    isHourmeter(type) {
      console.log(type);
      console.log(this.allType);
      let equipament = this.allType.find(x => x.id === type);
      console.log(equipament);
      if (equipament === undefined) return false;
      if (equipament.markerType === 1) return true;
      else return false;
    }
  }
};
</script>
